"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamCard = exports.TeamCardComponent = exports.TeamCardDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_1 = require("../elements/content");
var card_1 = require("../elements/card");
var location_label_1 = require("./location-label");
var use_lang_1 = require("../../hooks/use-lang");
var entity_type_icon_label_1 = require("./entity-type-icon-label");
var icon_label_1 = require("../elements/icon-label");
var person_photo_grid_1 = require("./person-photo-grid");
var organisation_cell_1 = require("./organisation-cell");
var cell_label_1 = require("../elements/cell-label");
var entity_count_label_1 = require("./entity-count-label");
var coalesce_1 = require("../../utils/coalesce");
var entity_cell_header_1 = require("./entity-cell-header");
exports.TeamCardDefaultProps = {};
// -------- Styles -------->
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2))
});
var CardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 8px;\n    box-sizing: border-box;\n    border-bottom: 1px solid ", ";\n    padding: ", " ", ";\n  "], ["\n    margin-top: 8px;\n    box-sizing: border-box;\n    border-bottom: 1px solid ", ";\n    padding: ", " ", ";\n  "])), theme_1.theme.COLOR('line-semi-subtle'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: 1.25em;\n    margin-top: ", "; \n    font-weight: 500;\n    color: ", ";\n    ", ";\n    padding-top: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: 1.25em;\n    margin-top: ", "; \n    font-weight: 500;\n    color: ", ";\n    ", ";\n    padding-top: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(21), theme_1.theme.UNIT(1), theme_1.theme.COLOR('bold'), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(4), theme_1.theme.COLOR('link-hover'))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var IconLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var LocationLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var PhotosStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 320px;\n    padding: ", ";\n    margin-bottom: ", ";\n    justify-content: flex-start;\n  "], ["\n    width: 320px;\n    padding: ", ";\n    margin-bottom: ", ";\n    justify-content: flex-start;\n  "])), theme_1.theme.UNIT(1), theme_1.theme.UNIT(3))
});
var OrganisationsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", "; \n    padding-top: ", "; \n  "], ["\n    ", ";\n    margin-top: ", "; \n    padding-top: ", "; \n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4))
});
var OrganisationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    &:last-child {\n      padding-bottom: 0;\n    }\n  "], ["\n    padding-bottom: ", ";\n    &:last-child {\n      padding-bottom: 0;\n    }\n  "])), theme_1.theme.UNIT(8))
});
var OrganisationsHeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var CountLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var FollowControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n    padding-left: 1px;\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n  "], ["\n    color: ", ";\n    ", ";\n    padding-left: 1px;\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.H_DOT_BG_END(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Card: (0, styled_components_1.default)(card_1.Card)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), CardStyles),
  Header: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  LocationLabel: (0, styled_components_1.default)(location_label_1.LocationLabel)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LocationLabelStyles),
  Photos: (0, styled_components_1.default)(person_photo_grid_1.PersonPhotoGrid)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), PhotosStyles),
  Title: styled_components_1.default.h1(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Label: (0, styled_components_1.default)(entity_type_icon_label_1.EntityTypeIconLabel)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  IconLabel: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), IconLabelStyles),
  CountLabel: (0, styled_components_1.default)(entity_count_label_1.EntityFieldCountLabel)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), CountLabelStyles),
  Organisations: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), OrganisationsStyles),
  OrganisationsHeader: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), OrganisationsHeaderStyles),
  Organisation: (0, styled_components_1.default)(organisation_cell_1.OrganisationCell)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles)
};
My.Card = (0, styled_components_1.default)(card_1.Card)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CardStyles);
var TeamCardComponent = function (props) {
  var className = props.className,
    entity = props.entity,
    path = props.path,
    badge = props.badge;
  var t = (0, use_lang_1.useLang)();
  var comments = entity.comments || [];
  var members = entity.members || [];
  var workstreams = entity.workstreams || [];
  var organisationMembers = (entity.organisationMembers || []).filter(function (om) {
    return !!om.organisation;
  });
  var description = (0, coalesce_1.coalesce)(entity, ['description.text', 'openGraph.description.text']);
  var people = members.map(function (member) {
    return member.person;
  });
  return React.createElement(My.Card, __assign({}, props, {
    space: 0,
    className: className,
    to: path,
    image: React.createElement(React.Fragment, null, React.createElement(My.Header, {
      entity: entity,
      badge: badge || entity.status && entity.status.name
    }), !!people.length && React.createElement(My.Photos, {
      people: people,
      rows: 2,
      columns: 4,
      spacing: 12,
      size: 56
    }))
  }), React.createElement(My.Title, null, entity.name), React.createElement(My.CountLabel, {
    entityTypeName: "Comment",
    value: comments
  }), React.createElement(My.CountLabel, {
    entityTypeName: "Person",
    value: members
  }), React.createElement(My.CountLabel, {
    entityTypeName: "Workstream",
    value: workstreams
  }), entity.location && React.createElement(My.Label, {
    entityTypeName: "Location"
  }, React.createElement(My.LocationLabel, {
    entity: entity.location
  })), description && React.createElement(My.Content, {
    tiny: true
  }, description));
};
exports.TeamCardComponent = TeamCardComponent;
exports.TeamCardComponent.defaultProps = exports.TeamCardDefaultProps;
exports.TeamCard = React.memo(exports.TeamCardComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;